import MenuButton from '../MenuButton.jsx'
import useMenuItemBdDtComplete from './useMenuItemBdDtComplete.jsx'
import useMenuItemBizReqDoc from './useMenuItemBizReqDoc.jsx'
import useMenuItemExportBizData from './useMenuItemExportBizData.jsx'
import useMenuItemImportArchPlan from './useMenuItemImportArchPlan.jsx'
import useMenuItemMigrateDe from './useMenuItemMigrateDe.jsx'
import useMenuItemProcessChange from './useMenuItemProcessChange.jsx'
import useMenuItemProcessDataObjectReverse from './useMenuItemProcessDataObjectReverse.jsx'
import useMenuItemProcessForeignKey from './useMenuItemProcessForeignKey.jsx'
import useMenuItemRevDelta from './useMenuItemRevDelta.jsx'

export default function MenuButtonMore(props) {
    const items = [
        useMenuItemRevDelta(),
        useMenuItemProcessForeignKey(),
        useMenuItemProcessDataObjectReverse(),
        useMenuItemBizReqDoc(),
        useMenuItemProcessChange(),
        useMenuItemBdDtComplete(),
        useMenuItemImportArchPlan(),
        useMenuItemExportBizData(),
        useMenuItemMigrateDe(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            更多
        </MenuButton>
    )
}
